import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import { useCallback, useState } from 'react';
import clsx from 'clsx';

interface IMenuItem {
  title: string;
  handleClick?: (isOpen: boolean) => void;
  defaultOpen?: boolean;
  children?: any;
  /** Compact spacing, e.g. for the mobile navigation drawer */
  dense?: boolean;
}

const useStyles = makeStyles(() => ({
  details: {
    padding: 0,
    display: 'block',
  },
  accordion: {
    marginBottom: 16,
    '&.Mui-expanded': {
      margin: 0,
      marginBottom: 16,
    },
    '&::before': {
      display: 'none',
    },
  },
  accordionSummary: {
    fontWeight: 700,
    minHeight: 48,
    '&.Mui-expanded': {
      minHeight: 48,
    },
    '& .MuiAccordionSummary-content': {
      margin: '12px 0',
    },
  },
  denseAccordion: {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  denseSummary: {
    minHeight: 44,
    padding: '0 12px',
    borderRadius: 12,
    '&.Mui-expanded': {
      minHeight: 44,
    },
    '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
    '& p': {
      margin: 0,
    },
  },
  denseDetails: {
    paddingLeft: 8,
  },
}));

export const ExpandableMenu = ({
  children,
  defaultOpen = false,
  handleClick,
  title,
  dense = false,
}: IMenuItem) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(defaultOpen);

  const onClick = useCallback(() => {
    setOpen(!isOpen);
    if (handleClick) handleClick(!isOpen);
  }, [isOpen]);

  return (
    <Accordion defaultExpanded={isOpen} elevation={0} onClick={onClick} className={clsx(classes.accordion, dense && classes.denseAccordion)}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={`${title}-content`}
        id={title}
        className={clsx(classes.accordionSummary, dense && classes.denseSummary)}
      >
        <p>{title}</p>
      </AccordionSummary>
      <AccordionDetails className={clsx(classes.details, dense && classes.denseDetails)}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
